import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-global-asset-popover',
  templateUrl: './global-asset-popover.component.html',
  styleUrls: ['./global-asset-popover.component.scss'],
})
export class GlobalAssetPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
